import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap';

import { CivilComponent } from './civil.component';
import { CivilSearchService } from './civil-search.service';
import { SharedModule } from './../shared/shared.module';
import { CivilSearchResultsTableComponent } from './civil-search-results-table/civil-search-results-table.component';
import { CivilSearchResultsPleadsGridComponent } from './civil-search-results-pleads-grid/civil-search-results-pleads-grid.component';
// tslint:disable-next-line:max-line-length
import { CivilIdentitySearchResultsTableComponent } from './civil-identity-search-results-table/civil-identity-search-results-table.component';
import { CivilIndexSearchResultsTableComponent } from './civil-index-search-results-table/civil-index-search-results-table.component';
import { CivilDisclaimerComponent } from './civil-disclaimer/civil-disclaimer.component';

@NgModule({
  imports: [
    AccordionModule,
    AlertModule,
    BsDropdownModule,
    PopoverModule,
    TabsModule,
    BsDatepickerModule,
    CommonModule,
    MultiselectDropdownModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [CivilComponent,
                 CivilSearchResultsTableComponent,
                 CivilSearchResultsPleadsGridComponent,
                 CivilIdentitySearchResultsTableComponent,
                 CivilIndexSearchResultsTableComponent,
                 CivilDisclaimerComponent],
  exports: [CivilComponent,
    CivilDisclaimerComponent,
                 CivilSearchResultsTableComponent,
                 CivilSearchResultsPleadsGridComponent],
  entryComponents: [
    CivilDisclaimerComponent
  ],
  providers: [DatePipe, CivilSearchService]
})
export class CivilModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil.module.ts